var React = require('react');

function Music (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.074 22.25C9.826 14.672 14.6 7.75 24 7.75s14.174 6.921 14.926 14.5a3 3 0 00-2.926 3v15c0 1.656 1.344 2.85 3 2.85h3a7.502 7.502 0 006-7.35v-6a7.502 7.502 0 00-6.05-7.36C41.253 13.085 35.046 4.75 24 4.75S6.746 13.085 6.05 22.39A7.502 7.502 0 000 29.75v6a7.5 7.5 0 007.5 7.5H9a3 3 0 003-3v-15a3 3 0 00-2.926-3zM45 35.75a4.5 4.5 0 01-4.5 4.5H39v-15h1.5a4.5 4.5 0 014.5 4.5v6zM7.5 25.25a4.5 4.5 0 00-4.5 4.5v6a4.5 4.5 0 004.5 4.5H9v-15H7.5z"}));
}

Music.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Music;

Music.default = Music;
